import React from 'react';

// Standard visually-hidden technique — keeps the node in the a11y tree (so
// `role="status"` and `aria-describedby` work) while collapsing it to a 1px
// box that paints nothing.
const visuallyHiddenStyle = {
  border: 0,
  clip: 'rect(0,0,0,0)',
  height: 1,
  margin: -1,
  overflow: 'hidden',
  padding: 0,
  position: 'absolute',
  whiteSpace: 'nowrap',
  width: 1
};
export const ScreenReaderOnlyStatus = _ref => {
  let {
    id,
    dataHook,
    children
  } = _ref;
  return /*#__PURE__*/React.createElement("span", {
    "data-hook": dataHook,
    id: id,
    role: "status",
    style: visuallyHiddenStyle
  }, children);
};
//# sourceMappingURL=screen-reader-only-status.js.map